<template>
  <nav class="floor-menu">
    <div
      v-for="(floor, i) in $root.list"
      :class="{'floor-menu__item':true, 'floor-menu__selected':(i==$root.floor_selected)}"
      @click="$root.changeFloorSelection(i)"
      :key="'floor_'+i"
    >{{floor.title}}</div>
  </nav>
</template>

<script>
export default {
  name: "FloorMenu"
};
</script>